export default __webpack_public_path__ + "static/media/start-sound.eb046177.wav";